import { Alert, AlertDescription, Text } from "@chakra-ui/react";
import React from "react";

type InstructionAlertType = "info" | "tip" | "warning";

const AlertTypeConfig: Record<
  InstructionAlertType,
  {
    status: "info" | "success" | "warning";
    bg: string;
    borderColor: string;
  }
> = {
  info: {
    status: "info",
    bg: "blue.50",
    borderColor: "blue.200",
  },
  tip: {
    status: "success",
    bg: "green.50",
    borderColor: "green.200",
  },
  warning: {
    status: "warning",
    bg: "orange.50",
    borderColor: "orange.200",
  },
};

export function InstructionAlert({
  type = "info",
  title,
  children,
}: {
  type?: InstructionAlertType;
  title?: string;
  children: React.ReactNode;
}): React.ReactElement {
  const config = AlertTypeConfig[type];

  return (
    <Alert
      status={config.status}
      variant="subtle"
      borderWidth="1px"
      bg={config.bg}
      borderColor={config.borderColor}
      borderRadius="md"
      flexDirection="column"
      alignItems="flex-start"
    >
      {title && (
        <Text fontSize="md" fontWeight="bold" mb={2}>
          {title}
        </Text>
      )}
      <AlertDescription>{children}</AlertDescription>
    </Alert>
  );
}
